import React, { useEffect } from 'react';
import './task-on-delete-modal.css';
import { Button, ButtonGroup } from 'reactstrap';
import Backdrop from '../../components/UI/backdrop';
import { bool, func } from 'prop-types';
import Portal from '../../hoc/portal';

const TaskOnDeleteModal = ({ onToggleShowModal, onDelete, deleteTaskId }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => document.body.style.overflow = ''
  })

  return (
    <Portal>
      <Backdrop onClick={() => onToggleShowModal()} />

      <div className="popup">
        <div className="popup-body">
          Вы уверены, что хотите удалить задачу?
        </div>
        <ButtonGroup>
          <Button color="primary" onClick={() => onDelete(deleteTaskId)}>Подтвердить</Button>
          &nbsp;
          <Button color="danger" onClick={() => onToggleShowModal()}>Отменить</Button>
        </ButtonGroup>
        <i className="fa fa-times" onClick={() => onToggleShowModal()}></i>
      </div>
    </Portal>
  )
}

TaskOnDeleteModal.propTypes = {
  showModal: bool,
  onToggleShowModal: func,
  onDelete: func,
}

TaskOnDeleteModal.defaultProps = {
  showModal: false,
  onToggleShowModal: () => { },
  onDelete: () => { },
}

export default TaskOnDeleteModal